import { axiosDefault } from '@/core/utils';

interface CounterTapsRequest {
	taps: number;
}

const sendCounterTaps = async ({ taps }: CounterTapsRequest) => {
	const url = `/tg/user/energy?value=${taps}`;
	const response = await axiosDefault.put(url);
	return {
		currentCoins: response.data.currentCoins,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

export const CounterService = {
	sendCounterTaps,
};
